var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mo-clickable-image",on:{"click":function($event){return _vm.$emit('click')}}},[_c('vl-image',_vm._b({},'vl-image',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }